export default "__VITE_ASSET__D$CiUP1M__"